import React, { useContext } from 'react';
import { Panel } from "../../components/Panel";
import ClientPartnerDisplayComponentForm from "app/components/ClientPartnerDisplayComponentForm";
import IconComponent from "../../components/IconComponent";
import {AppContext, AppContextType} from "../../context/AppContext";
import {Params, useParams} from "react-router";
import {getBreadcrumb, setBreadcrumb} from "../../components/Breadcrumb";
import {ModelPartnerClient} from "@dia-ui/util_interlink-api";
import {RouteItem} from "../../routes";


export function ClientPartnerDisplay() {
  const {
    getRoutes
  } = useContext(AppContext);

  /**
   * params
   */
  const { partnerId, type } = useParams();

  /**
   * ROUTE_CONFIG
   */
  const ROUTE_CONFIG = getRoutes();

  return (
    <>
      <Panel
        header={
          <>
            <IconComponent iconName={ ROUTE_CONFIG.CLIENT_PARTNER_VIEW_EDIT.icon } />
            { getBreadcrumb("CLIENT_PARTNER_VIEW_EDIT") } &nbsp;<i data-icon-before="link"></i> { getBreadcrumb("CLIENT_VIEW_EDIT", "clean") }
          </>
        }
      >
        { partnerId && type && <ClientPartnerDisplayComponentForm id={ partnerId } type={ type } /> }
      </Panel>
    </>
  );
}

/**
 * ClientPartnerLoader
 * @param context
 * @param id
 * @param type
 * @constructor
 */
function ClientPartnerLoader(context: AppContextType, id: string, type: string): Promise<ModelPartnerClient> {
  return context.services.servicePartnerClient.getByIdAndType(id, type);
}

/**
 * ClientPartnerDisplayBreadcrumb
 * @param route
 * @param context
 * @param params
 * @constructor
 */
export function ClientPartnerDisplayBreadcrumb(route: RouteItem, context: AppContextType, params: Params<string>): string | undefined {
  (async () => {
    if (!params.partnerId || !params.type) return;

    const partnerClient: ModelPartnerClient = await ClientPartnerLoader(context, params.partnerId, params.type);
    if (partnerClient && partnerClient[0] && partnerClient[0].partnerId) {
      setBreadcrumb("CLIENT_PARTNER_VIEW_EDIT", partnerClient[0].partnerId, "append");
    }
  })();

  return route.title;
}
